import { NavbarController } from './NavbarController';
import NavbarView from './NavbarView.html';
const AFFIX_OFFSET_DESKTOP = 6;
const AFFIX_OFFSET_MOBILE = 3;
export class NavbarDirective {
    static $inject = ['$compile', '$window', 'WindowService'];
    constructor($compile, $window, WindowService) {
        'ngInject';
        this.$compile = $compile;
        this.$window = $window;
        this.WindowService = WindowService;
        this.restrict = 'E';
        this.template = NavbarView;
        this.controller = NavbarController;
        this.controllerAs = '$ctrl';
        this.transclude = true;
        this._y = $window.pageYOffset;
        this._offsetY = 0;
    }
    compile() {
        return this.link.bind(this);
    }
    link(scope, element) {
        // Navbar goes up when scrolling down and comes down when scrolling up.
        // this.$nav = element.find('nav')[0];
        /* let updateNavbarOffsetListener = this._updateNavbarOffset.bind(this);

        this.WindowService.element.on('scroll', updateNavbarOffsetListener);
        scope.$on('$destroy', () =>
            this.WindowService.element.off(
                'scroll',
                updateNavbarOffsetListener,
            ),
        ); */
    }
    _updateNavbarOffset() {
        const dy = this.$window.pageYOffset - this._y;
        this._y = this.$window.pageYOffset;
        this._offsetY = Math.min(0, Math.max(this._offsetY - dy, -this.$nav.offsetHeight + this.affixOffset));
        this.$nav.style.top = this._offsetY + 'px';
    }
    get affixOffset() {
        return this.WindowService.isMobile
            ? AFFIX_OFFSET_MOBILE
            : AFFIX_OFFSET_DESKTOP;
    }
    get scope() {
        return {
            loading: '=navbarLoading',
        };
    }
    static factory($compile, $window, WindowService) {
        return new NavbarDirective($compile, $window, WindowService);
    }
}
NavbarDirective.$inject = ['$compile', '$window', 'WindowService'];
NavbarDirective.factory.$inject = ['$compile', '$window', 'WindowService'];
